import * as React from "react";
import { Form } from "formsy-react";
import { Rule } from "./rule";

interface IProps {
    groupId;
    onAddValue;
    onRemoveRule;
    onRemoveValue: (groupId, ruleId, value) => void;
    onSelectField;
    rules;
    topLevelFields;
    filters;
    filterValues;
    onToggleRuleType;
    onFetchFilterValues;
    onResetFilterValues?: () => void;
}

export class Rules extends React.PureComponent<IProps, any> {
    render() {
        const {
            groupId,
            onAddValue,
            onRemoveRule,
            onRemoveValue,
            onSelectField,
            rules,
            topLevelFields,
            filters,
            filterValues,
            onToggleRuleType,
            onFetchFilterValues,
            onResetFilterValues,
        } = this.props;
        const fieldsNotInUse = topLevelFields.filterNot((field, key) =>
            rules.find((rule) => rule.get("field") === key),
        );

        return (
            <Form className="rules">
                {rules.map((rule) => {
                    const field = rule.get("field");
                    const _id = rule.get("_id");
                    let filteredTopLevelFields = fieldsNotInUse;
                    if (field !== "" && topLevelFields.get(field)) {
                        filteredTopLevelFields = fieldsNotInUse.set(field, topLevelFields.get(field));
                    }
                    return (
                        <Rule
                            filters={filters}
                            filterValues={filterValues}
                            groupId={groupId}
                            key={_id}
                            onAddValue={onAddValue}
                            onFetchFilterValues={onFetchFilterValues}
                            onRemoveRule={onRemoveRule}
                            onRemoveValue={onRemoveValue}
                            onResetFilterValues={onResetFilterValues}
                            onSelectField={onSelectField}
                            onToggleRuleType={onToggleRuleType}
                            rule={rule}
                            topLevelFields={filteredTopLevelFields}
                        />
                    );
                })}
            </Form>
        );
    }
}

export default Rules;
